
export default function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white pt-32 pb-20 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6f794bf491448118ad818d637699cf35.jpg')`,
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/95 via-slate-800/90 to-slate-900/95" />

      <div className="relative z-10 container mx-auto px-6">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-400/30 text-emerald-300 text-sm font-bold px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm">
            <i className="ri-shield-check-line text-lg"></i>
            <span>現役ホストによる実務型サポート</span>
          </div>

          {/* Main Title */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold mb-6 leading-tight tracking-tight">
            Tokyo Minpaku &<br />
            Ryokan Support
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-slate-300 mb-10 leading-relaxed font-light">
            Launch, Operate and Scale<br className="md:hidden" /> Your Airbnb Business in Tokyo
          </p>

          {/* Description */}
          <p className="text-base md:text-lg text-slate-400 mb-12 max-w-3xl mx-auto leading-relaxed">
            簡易宿所申請から運営代行・清掃管理まで、<br className="hidden md:block" />
            東京での民泊ビジネスを成功に導く総合サポート
          </p>

          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className="group inline-flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-400 text-white text-lg font-bold px-10 py-5 rounded-xl transition-all duration-200 hover:shadow-[0_8px_40px_rgba(16,185,129,0.4)] hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-2xl"></i>
            <span>お問い合わせ・無料相談</span>
            <div className="w-7 h-7 flex items-center justify-center bg-white/20 rounded-full group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </button>

          {/* Trust Indicators */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/20 rounded-lg mx-auto mb-3">
                <i className="ri-building-4-line text-2xl text-emerald-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-1">運営中</div>
              <div className="text-sm text-slate-400">自社宿泊施設</div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/20 rounded-lg mx-auto mb-3">
                <i className="ri-file-list-3-line text-2xl text-emerald-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-1">実績あり</div>
              <div className="text-sm text-slate-400">簡易宿所申請</div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/20 rounded-lg mx-auto mb-3">
                <i className="ri-team-line text-2xl text-emerald-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-1">連携</div>
              <div className="text-sm text-slate-400">会計事務所</div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 hover:bg-white/10 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center bg-emerald-500/20 rounded-lg mx-auto mb-3">
                <i className="ri-service-line text-2xl text-emerald-400"></i>
              </div>
              <div className="text-3xl font-bold text-white mb-1">一貫対応</div>
              <div className="text-sm text-slate-400">運営〜清掃</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Accent */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-emerald-500 to-transparent" />
    </section>
  );
}
